import { orderOrigins } from './orderOrigins';

export const getOrderOriginByLabel = (label) => {
  const orderOriginByLabel = orderOrigins.filter(({ label: originLabel }) => originLabel === label);

  return orderOriginByLabel[0];
};
